<template>
  <div class="pd-medium">
    <h2 class="h4 mn-b-medium">{{ $t('plans.title') }}</h2>

    <div v-if="loading" class="t-center pd-big">
      <Loader />
    </div>

    <div v-else class="cols-3 mobile:cols-1 gap-small">
      <CardPlan
        v-for="plan in plans"
        :key="plan._id"
        :plan="plan"
        @select="handleSelect"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import Loader from '@martyrs/src/design-system/components/Loader/Loader.vue';
import CardPlan from '../blocks/CardPlan.vue';

const store = inject('store');
const plans = ref([]);
const loading = ref(true);

onMounted(async () => {
  try {
    plans.value = await store.subscriptions.actions.listPlans();
  } finally {
    loading.value = false;
  }
});

async function handleSelect(plan) {
  const { showPayment } = await import('../../plugins/popup.payment.plugin.js');
  try {
    await showPayment({
      amount: plan.amount.value,
      currency: plan.amount.currency,
      description: plan.name,
      mode: 'subscription',
      planId: plan._id,
    });
  } catch (err) {
    // User cancelled — do nothing
  }
}
</script>
